module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_7005.af689dac.png";